/// <amd-module name="Core/Medius.Core.Web/Scripts/components/taskHandling/shared/modals/rejectManagementWizard/services"/>
import {get, post} from "Core/Medius.Core.Web/Scripts/Medius/core/fetch/rest";
import { CompanyConfiguration, DefaultSupplierEmail, IEligibleForEmailCommunication, IEmailContent, IEmailSettings, IRejectionAction, IRejectManagementReasonCode, ISupplierInvoiceRejectionDto, RejectionEmailContentRequestDto } from "./interfaces";

export function getActiveRejectManagementReasonCodes(hierarchyId: string):Promise<Array<IRejectManagementReasonCode>> {
    return get(`remedium-api/apa/rejectManagement/activeReasonCodes?hierarchyId=${encodeURIComponent(hierarchyId)}`);
}

export async function getEmailEligibility(documentId: number): Promise<IEligibleForEmailCommunication | null> {
    return get(`remedium-api/apa/rejectManagement/emailEligibility?documentId=${documentId}`);
}

export async function postISupplierInvoiceRejectionDto(reasonCode: ISupplierInvoiceRejectionDto): Promise<number> {
    return post("remedium-api/apa/rejectManagement/reject", reasonCode);
}

export async function getEmailSettings(documentId: number): Promise<IEmailSettings> {
    return get(`remedium-api/apa/rejectManagement/emailSettings/${documentId}`);
}

export async function getActiveRejectionActions(hierarchyId: string): Promise<IRejectionAction[]> {
    return get(`remedium-api/apa/rejectionAction/activeActions?hierarchyId=${encodeURIComponent(hierarchyId)}`);
}

export async function getCompanyConfiguration(companyId: number): Promise<CompanyConfiguration> {
    return get(`remedium-api/apa/rejectManagement/companyConfiguration/${companyId}`);
}

export async function getSelectedReasonCodes(documentId: number): Promise<Array<IRejectManagementReasonCode>> {
    return get(`remedium-api/apa/rejectManagement/invoices/${documentId}/rejection-reasons`);
}

export async function getRejectionEmailAiContent( documentId: number, rejectionEmailContentRequestDto: RejectionEmailContentRequestDto ): Promise<IEmailContent> {
    return post(`remedium-api/apa/rejectManagement/rejectionEmail/${documentId}`, rejectionEmailContentRequestDto);
}

export async function getDefaultSupplierEmail( documentId: number): Promise<DefaultSupplierEmail> {
    return get(`remedium-api/apa/rejectManagement/supplier/defaultEmail/${documentId}`);
}